import { MutationTree } from "vuex";

import { CompanyInformationState } from "../types";

const mutations: MutationTree<CompanyInformationState> = {
  setZipcode(state, zipcode) {
    state.zipcode = zipcode;
  },
  setCity(state, city) {
    state.city = city;
  },
  setAddressLine1(state, addressLine1) {
    state.addressLine1 = addressLine1;
  },
  setAddressLine2(state, addressLine2) {
    state.addressLine2 = addressLine2;
  },
  setWebsiteUrl(state, websiteUrl) {
    state.websiteUrl = websiteUrl;
  },
  setCountry(state, country) {
    state.country = country;
  },
  setBillingContactName(state, billingContactName) {
    state.billingContactName = billingContactName;
  },
  setBillingContactEmail(state, billingContactEmail) {
    state.billingContactEmail = billingContactEmail;
  },
  setName(state, name) {
    state.name = name;
  },
};

export default mutations;
